import { render } from "./PromoType.vue?vue&type=template&id=07418888&scoped=true"
import script from "./PromoType.vue?vue&type=script&lang=js"
export * from "./PromoType.vue?vue&type=script&lang=js"

import "./PromoType.vue?vue&type=style&index=0&id=07418888&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07418888"]])

export default __exports__